import { merchantKnowledgeArticleSchema } from "@redotech/shopper-agent-knowledge-common/merchant-knowledge-view";
import * as z from "zod";
import { UrlSchema } from "../common/url-parser";

/** URLs the merchant pastes in; each yields zero or more published articles. */
export const scrapeKnowledge = {
  name: "scrapeKnowledge" as const,
  input: z
    .object({
      urls: z
        .array(UrlSchema)
        .min(1, { message: "At least one URL is required" })
        .max(5, { message: "Maximum of 5 URLs allowed per request" }),
    })
    .strict(),
  output: z.array(
    z.object({
      url: z.string(),
      knowledge: z.array(merchantKnowledgeArticleSchema),
    }),
  ),
};
